import { Extension } from "..";
import { EditorState, TextSelection, Transaction } from "prosemirror-state";

type SupportedKeys = "Home" | "End";

/**
 * Normalizes standard keyboard behaviours across platforms with the exception of windows, such as home and
 * end.
 *
 * Home and End are not implemented at all for contentEditable on Safari, and
 * have platform-specific behaviour elsewhere.
 */
export class Keyboard extends Extension {
	get name() {
		return "keyboard";
	}

	handleKey = (keyname: SupportedKeys) => {
		return (state: EditorState, dispatch: ((tr: Transaction) => void) | undefined) => {
			const { selection } = state;

			// On windows users expect Home / End to jump to the start / end of a line, which is the default behaviour.
			if (window.navigator?.platform?.startsWith("Win")) {
				return false;
			}

			if (selection.empty) {
				const { $anchor } = selection;
				const tr = state.tr;

				switch (keyname) {
					case "Home":
					case "End": {
						const newPos = (keyname === "End" ? $anchor.end : $anchor.start).bind($anchor)($anchor.depth);
						const newSelection = TextSelection.findFrom(
							tr.doc.resolve(newPos),
							-1 /* Always search backwards */,
							true /* Only consider other text nodes as valid positions */,
						);

						if (newSelection) {
							tr.setSelection(newSelection);
							dispatch?.(tr);
							return true;
						}
						break;
					}
				}
			}
			return false;
		};
	};

	keys() {
		return {
			Home: this.handleKey("Home"),
			End: this.handleKey("End"),
		};
	}
}
